import { render } from "./wage-result-totaloverview.vue?vue&type=template&id=5dc03a0f"
import script from "./wage-result-totaloverview.vue?vue&type=script&lang=js"
export * from "./wage-result-totaloverview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/applications/wagesetting/wage-result-totaloverview.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5dc03a0f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5dc03a0f', __exports__)) {
    api.reload('5dc03a0f', __exports__)
  }
  
  module.hot.accept("./wage-result-totaloverview.vue?vue&type=template&id=5dc03a0f", () => {
    api.rerender('5dc03a0f', render)
  })

}


export default __exports__